import React from 'react';

import {
  EnumMerchantPaidMethod,
  EnumMerchantPaidStatus,
  EnumOrderMerchantStatus,
  EnumOrderStatus,
  EnumOrderUpdateStatus,
} from '../../../../../constants/enum';
import { trans } from '../../../../../localization/index';

function isAllowCancelOrder(itemDetail) {
  const {
    allow_cancel: allowCancel,
    order_status: orderStatus,
    pay_to_merchant: payToMerchant,
  } = itemDetail;
  const { state: payState, type: payType } = payToMerchant;

  return (
    allowCancel &&
    [
      EnumOrderStatus.CONFIRMED.id,
      EnumOrderStatus.AUTO_ASSIGN.id,
      EnumOrderStatus.AUTO_ASSIGN_TIMEOUT.id,
      EnumOrderStatus.ASSIGNED.id,
      EnumOrderStatus.REASSIGNED.id,
      EnumOrderStatus.INCHARGED.id,
      EnumOrderStatus.DENIED.id,
    ].includes(orderStatus) &&
    payType === EnumMerchantPaidMethod.TOPPAY.id &&
    payState === EnumMerchantPaidStatus.PAID
  );
}

export function OrderDetailAction({
  isHaveChangeOrder,
  itemDetail,
  handleTransferOrder,
  handleUpdateOrder,
  handleOpenRejectOrder,
}) {
  const { status, done, is_asap: isASAP } = itemDetail;
  const isScheduledOrderAndNotMeetDeadline = !isASAP && status === EnumOrderMerchantStatus.VERIFIED.id;

  return (
    <React.Fragment>
      {isAllowCancelOrder(itemDetail) && (
        <button
          type="button"
          className="btn btn-decline"
          onClick={() => handleUpdateOrder(EnumOrderUpdateStatus.CANCEL.id)}
        >
          {trans('mod_detail_update_cancel_order')}
        </button>
      )}
      {isHaveChangeOrder && (
        <React.Fragment>
          {!isScheduledOrderAndNotMeetDeadline &&
            <button
              type="button"
              className="btn btn-white mr-2"
              onClick={handleTransferOrder}
            >
              {trans('transfer_order_to_another_branch')}
            </button>
          }
          {!isScheduledOrderAndNotMeetDeadline &&
            <button
              type="button"
              className="btn btn-white"
              onClick={() =>
                handleUpdateOrder(
                  EnumOrderUpdateStatus.CONFIRM.id,
                  isHaveChangeOrder,
                )
              }
            >
              {trans('mod_detail_update_order')}
            </button>
          }
        </React.Fragment>
      )}
      {(isHaveChangeOrder || isScheduledOrderAndNotMeetDeadline) && (
        <button
          type="button"
          className="btn btn-decline"
          onClick={() =>
            handleOpenRejectOrder(true)
          }
        >
          {trans('mod_detail_reject_order')}
        </button>
      )}
      {status === EnumOrderMerchantStatus.CONFIRMED.id && (
        <button
          disabled={done > 0}
          type="button"
          className="btn btn-red"
          onClick={() => handleUpdateOrder(EnumOrderUpdateStatus.DONE.id)}
        >
          {trans('mod_detail_done_process_order')}
        </button>
      )}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/components/OrderDetailAction.jsx